import { Components, Theme } from '@mui/material';

export const skeletonComponentOverrides: Components<Theme>['MuiSkeleton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.grey[100],
    }),
  },
};
